import type { FaireProductEntity } from "../../entity_types/product";

export const p_t2x6bm7rzq: FaireProductEntity = {
  token: "p_t2x6bm7rzq",
  type: "product",
  name: "Bunch of Dogs Blue Porcelain Yunomi Tea Cup – 10 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/3f8b57518d375429556b506b619293901bea8d9fa1a57fbefea6f5b5d49d468c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38453adf032f1e432f1499e642b20a5dc1579a07bc524b33926d07dbf29e44c9.jpeg",
    "https://cdn.faire.com/fastly/047640c3412610265f8b3cee0b896a2f05081088110c53b5011c06e1239d03e3.jpeg",
    "https://cdn.faire.com/fastly/af2b8a89efcf2ad35f6121fa5b1f23df0c2f5b8ddc3bde816afefa95c8a244e1.jpeg"
  ],
  priceDollars: 5.5,
  description: "Serve hot green tea the Japanese way with this 10 oz yunomi tea cup in Bunch of Dogs Blue. It is decorated with a playful bunch of dogs in blue. Made in Japan from durable porcelain, it is built for sushi bars, ramen shops, cafés and Japanese restaurants, while looking just as good at home. A thoughtful gift for tea lovers and dog lovers.\n\nFeatures\n\n * Classic yunomi shape: a tall, handleless cup that is comfortable to hold with both hands \n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \nSpecifications\n\n * Size: 2.75\" Dia x 4\" H \n * Capacity: 10 fl oz \n * Material: Porcelain \n * Design: Bunch of Dogs Blue \n * Inner pack: 6 \n * Case pack: 60 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 12.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:05.850Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
